import cookie from 'js-cookie';
import { getStoredCurrLocation } from '@m2h/common/utils/location';

// temp定位生效灰度逻辑
const MOTUO_20KM_BOUNDS = {
  // 北边界 = 29.328133884469985 + 0.1797
  north: 29.5078338844699,
  // 南边界 = 29.328133884469985 - 0.1797
  south: 29.1484338844699,
  // 东边界 = 95.3320659027996 + 0.2056
  east: 95.5376659027996,
  // 西边界 = 95.3320659027996 - 0.2056
  west: 95.1264659027996
};

/**
 * 最简便快捷的方式：判断坐标是否在墨脫縣20公里正方形区域内
 * @param latitude 纬度（字符串或数字）
 * @param longitude 经度（字符串或数字）
 * @returns 是否在区域内
 */
export function isInMotuo20kmSquare(latitude: string | number, longitude: string | number): boolean {
  const lat = typeof latitude === 'string' ? parseFloat(latitude) : latitude;
  const lng = typeof longitude === 'string' ? parseFloat(longitude) : longitude;

  return lat >= MOTUO_20KM_BOUNDS.south
    && lat <= MOTUO_20KM_BOUNDS.north
    && lng >= MOTUO_20KM_BOUNDS.west
    && lng <= MOTUO_20KM_BOUNDS.east;
}

// 根据定位设置灰度标记
export function setGrayCookies({ userId }) {
  const { latitude, longitude } = getStoredCurrLocation();
  if (latitude && longitude && isInMotuo20kmSquare(latitude, longitude)) {
    cookie.set('mgray', 'mgray');
  } else {
    cookie.set('mgray', '0');
  }
  cookie.set('userId', userId);
}
